import { useAppSelector } from "@/store/app/hooks";
import { carrierReportDataSelector } from "@/store/features/carrier-report/carrierReportSelectors";

import { cn } from "@nextui-org/theme";
import { FC } from "react";
import { OTRFactoringAdBlock } from "./OTRFactoringAdBlock";

interface Props {
  withoutFactoring?: boolean;
}

export const Heading: FC<Props> = ({ withoutFactoring }) => {
  const carrierReportData = useAppSelector(carrierReportDataSelector);

  const isOTRDataAvailable = !!carrierReportData?.otrFactoringInfo;

  const { dbaName, legalName, docketNumbers, dotNumber } =
    carrierReportData || {};

  const companyDataClassName = cn(
    "flex",
    withoutFactoring
      ? "flex-row flex-wrap items-baseline gap-2"
      : "flex-col gap-1"
  );

  const companyNameClassName = cn(
    "text-xl font-semibold ",
    withoutFactoring ? "flex-shrink-0" : "max-w-80"
  );

  return (
    <div className="col-span-6 flex justify-between">
      <div className={companyDataClassName}>
        <h2 className={companyNameClassName}>{dbaName || legalName || ""}</h2>
        <p className="text-gray-500 text-sm">
          {docketNumbers?.join(", ")}
          {dotNumber && " | DOT " + dotNumber}
        </p>
      </div>
      {!withoutFactoring && isOTRDataAvailable && <OTRFactoringAdBlock />}
    </div>
  );
};
